import { type ReactNode } from 'react'
import {
  Info,
  SpacingToken,
  Tooltip,
} from '@livechat/design-system-react-components'
import { css } from '@emotion/react'

import Check from '@/assets/images/check.inline.svg'

const triggerCss = css`
  > span {
    top: 0px;
    padding: var(${SpacingToken.Spacing1}) var(${SpacingToken.Spacing2});
  }
`

const tooltipCss = css`
  width: 260px;
`

interface Props {
  children: ReactNode
}

const VerifiedAppTooltip = ({ children }: Props) => (
  <Tooltip
    css={tooltipCss}
    triggerRenderer={<span css={triggerCss}>{children}</span>}
  >
    <Check />
    <Info
      header="App verified by LiveChat"
      text="This app went through a detailed usability review to ensure its high
          quality from the user perspective."
    />
  </Tooltip>
)

export default VerifiedAppTooltip
